<div class="card card-custom">
    <div class="card-header">
        <div class="card-title">
            <h3 class="card-label">Add Apartment</h3>
        </div>
        <div style="width: 20%"></div>
    </div>

    <div class="form form-group-seperator-dashed">
        <form class="form" [formGroup]="assetClassResidentialForm" *ngIf="assetClassResidentialForm">
            <div class="card-body">

                <mat-dialog-content>
                    <kt-tab-header [innerTop]="'0px'" [headerLabels]="tabHeaders" (tabChange)="onTabChange($event)"
                        [selectedTabChange]="selectedtabchange$">
                    </kt-tab-header>
                    <mat-tab-group class="invinsible-tabs" [(selectedIndex)]="selectedTab"
                        (selectedTabChange)="onTabChanged($event);">
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <span>Location & building</span>
                            </ng-template>
                            <div class="card-body pt-0 mad-container">
                                <div class="card-body-progress">
                                    <mat-spinner [diameter]="20"></mat-spinner>
                                </div>
                                <app-comparable-location
                                    [centerLatitude]="centerLat"
                                    [centerLongitude]="centerLng"
                                    [locationInfo]="null"
                                ></app-comparable-location>
                            </div>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <span>Property information</span>
                            </ng-template>
                            <div class="card-body pt-0 mad-container">
                                <!-- <kt-form-error [hasFormErrors]="hasFormErrors" [tabHeaders]="tabHeaders" [error]="error"
                                    [erroTabMap]="erroTabMap()" (hasFormErrorsChange)="onHasFormErrorsChange($event)">
                                </kt-form-error> -->

                                <div class="form-group kt-form__group row section-margin-top-60">
                                    <div class="col-lg-12 kt-margin-bottom-20-mobile">
                                        <h5 class="my-3 text-mad text-uppercase">
                                            About the property
                                        </h5>
                                        <hr class="active">
                                    </div>

                                    <div class="col-lg-4 kt-margin-bottom-20-mobile">
                                        <mat-form-field class="mat-form-field-fluid">
                                            <mat-select placeholder="Sub-type category"
                                                formControlName="sub_type_category_id">
                                                <mat-option *ngFor="let item of (filteredSubTypeCategories|async)"
                                                    [value]="item.id">{{item.name}}</mat-option>
                                            </mat-select>
                                            <mat-error>
                                                Sub-type category <strong>required</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>

                                    <div class="col-lg-4 kt-margin-bottom-20-mobile"
                                        *ngIf="filteredSubCategories.length != 0">
                                        <mat-form-field class="mat-form-field-fluid">
                                            <mat-select placeholder="Sub-category" formControlName="sub_category_id">
                                                <mat-option *ngFor="let item of filteredSubCategories"
                                                    [value]="item.id">{{item.name}}</mat-option>
                                            </mat-select>
                                            <mat-error>
                                                Sub-category <strong>required</strong>
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>

                                <kt-ac-size class="section-margin-top-60" [sizesSubject]="sizesSubject"
                                    [assetClassType]="'1'"></kt-ac-size>
                                <mat-error class="tag-custom-error mt-2"
                                    *ngIf="hasFormErrors && sizesSubject.value.length == 0" [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('RETAIL_SHOP.FORM.FIELD.SIZES.SECTION_TITLE' | translate)
                                }">
                                </mat-error>
                            </div>
                        </mat-tab>
                        <mat-tab>
                            <ng-template mat-tab-label>
                                <span>Lease & sale information</span>
                            </ng-template>
                            <div class="card-body pt-0 mad-container">
                                <!-- <kt-form-error [hasFormErrors]="hasFormErrors" [tabHeaders]="tabHeaders" [error]="error"
                                    [erroTabMap]="erroTabMap()" (hasFormErrorsChange)="onHasFormErrorsChange($event)">
                                </kt-form-error> -->

                                <kt-consideration-and-source style="margin-top: 60px;"
                                    [inputConsiderations]="tenuresSubject|async"
                                    [landAreaComponentListSubject]="comps" 
                                    [hasParcelInfo$]="hasParcel"
                                    [sizes]="sizes$|async"
                                    (considerationsChange)="onConsiderationsChange($event)">
                                </kt-consideration-and-source>
                                <mat-error class="tag-custom-error mt-2"
                                    *ngIf="hasFormErrors && (considerationError$|async)" [innerHtml]="'GENERAL.VALIDATION.REQUIRED' | translate:{
                                    field: ('APARTMENT.FORM.FIELD.CONSIDERATIONS.TITLE' | translate)
                                }">
                                </mat-error>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                </mat-dialog-content>
            </div>
        </form>
        <div class="card-footer b-0 p-0 text-right">
            <div class="form-actions form-actions-solid">
                <button mat-button mat-raised-button (click)="cancel()">
                    Cancel
                </button>
                &nbsp;
                <button type="button" class="btn btn-success" mat-raised-button color="submit" (click)="onSubmit(true)">
                    Save
                </button>
            </div>
        </div>
    </div>
</div>